import React, { useState, useEffect } from 'react';
import {
  Pane, majorScale, TextInput, FormField, toaster,
} from 'evergreen-ui';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { api } from '../../../../services/api';
import { searchParams } from '../../../../services/history';
import BaseSheet from '../../../../components/sidesheets/base';
import { CustomTagInput } from '../../../../components/inputs';
import formHelp from '../../../../constants/help';

const EditSheet = ({ visible, close }) => {
  const id = searchParams.get('selected');
  const [loading, setLoading] = useState(true);

  const validateForm = (values) => {
    const errors = {};
    if (!values.name || values.name.length < 1) {
      errors.name = 'This field is required';
    }
    return errors;
  };

  const submitForm = async (values) => {
    try {
      await api.teams.update(id, values);
      toaster.success('Team updated successfully');
      close();
    } catch (error) {
      toaster.danger('There was an error while proccessing your request');
    }
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: submitForm,
    validate: validateForm,
    validateOnChange: true,
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await api.teams.get(id);
        formik.setFieldValue('name', data.name);
        formik.setFieldValue('aliases', data.aliases);
        setLoading(false);
      } catch (error) {
        toaster.danger('There was an error while proccessing your request');
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const form = (
    <Pane>
      <FormField label="Team name" validationMessage={formik.errors.name}>
        <TextInput
          name="name"
          onChange={formik.handleChange}
          defaultValue={formik.values.name}
          isInvalid={formik.errors.name && true} />
      </FormField>
      <FormField label="Team aliases" marginTop={majorScale(2)}>
        <CustomTagInput
          name="aliases"
          defaultValue={formik.values.aliases}
          onChange={(values) => formik.setFieldValue('aliases', values)} />
      </FormField>
    </Pane>
  );

  return (
    <BaseSheet.Edit
      form={form}
      close={close}
      help={formHelp.team}
      visible={visible}
      loading={loading}
      submitLoading={false}
      submitDisabled={Object.keys(formik.errors).length > 0}
      title="team"
      onSubmit={formik.handleSubmit} />
  );
};

EditSheet.propTypes = {
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default EditSheet;
